$('.list-box-links--extra .box--square-link--more').on('click', function() {
  $(this).closest('.list-box-links--extra').addClass('active');
});
